import NAME from "./constants";

export const getLoading = store => store[NAME].isLoading;
export const getData = store => store[NAME].data;
export const getColaborators = store => store[NAME].colaborators;
export const getGroups = store => store[NAME].groups;
export const getTypeList = store => store[NAME].typeList;
export const getStatusList = store => store[NAME].statusList;